import styled from 'styled-components';

import { StyledTable as Table } from 'components/DataTable/DataTable.style';

export const StyledTable = styled(Table)`
  border: 1px solid ${({ theme }) => theme.borderColor};
  margin-top: 1em;
`;
